// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"cac79280","207":"310bee15"}[chunkId] + ".chunk.css";
};